import { useAuthUser } from "../../hooks/useAuthUser";
import LOGO from "../../../../assets/images/logo/LOGO.svg";
import FloatingMenu from "../../components/menu/FloatingMenu";
const BusinessClosedPage = () => {
  const { details } = useAuthUser();
  const displayName = details?.companyName;

  return (
    <div>
      <div className="fixed-right">
        <FloatingMenu logoutButton={true} homeButton={true} isBusiness={true} />
      </div>
      <div className="message-flex">
        <div className="message-container">
          <h1>Hi, {displayName}</h1>
          <p>
            You are currently unable to place orders. This can be due to
            shortness of staff or availability issues with the harvest. Please
            check back in tomorrow.
          </p>
          <div className="image">
            <img src={LOGO} alt="Alnarp's Farm Logo" />
          </div>
        </div>
      </div>
    </div>
  );
};

export default BusinessClosedPage;
